function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.531 21.656c1.203-3.995 3.541-5.879 5.011-6.413V2.416H5.717c-1.924 0-2.806 1.87-3.006 2.806-.267 1.27-.962 4.61-1.603 7.816-.642 3.207 1.737 3.608 3.006 3.407l6.413-.6c-.601.6-1.626 2.483-2.405 4.81-1.002 2.992 3.267 4.796 4.41 1.001z",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M23.955 17.033h-6.413V1h6.413z"
});

var SvgThumbDownWhite = function SvgThumbDownWhite(props) {
  return React.createElement("svg", _extends({
    width: 88,
    height: 25,
    viewBox: "-30 0 88 25",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml,%3Csvg width='88' height='25' viewBox='-30 0 88 25' fill='none' xmlns='http://www.w3.org/2000/svg' %3E %3Cpath d='M12.5315 21.6563C13.734 17.6609 16.0722 15.7773 17.542 15.2429L17.542 2.416L5.7172 2.416C3.79316 2.416 2.91131 4.28659 2.71089 5.22188C2.44367 6.49121 1.74888 9.83155 1.10753 13.0383C0.466185 16.245 2.84451 16.6458 4.11383 16.4454L10.5273 15.8442C9.92602 16.4454 8.90087 18.3284 8.12224 20.6542C7.12014 23.6475 11.3893 25.4513 12.5315 21.6563Z' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' /%3E %3Crect x='23.9551' y='17.0337' width='6.41345' height='16.0336' transform='rotate(-180 23.9551 17.0337)' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' /%3E %3C/svg%3E";
export { SvgThumbDownWhite as ReactComponent };